import { render, staticRenderFns } from "./myCowviewdetails.vue?vue&type=template&id=7047f89b&"
import script from "./myCowviewdetails.vue?vue&type=script&lang=js&"
export * from "./myCowviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports